import React from "react";
import type { BettingPoolWithCreator } from "~/models/league";
import GreenChip from "~/components/chip/GreenChip";
import GreyChip from "~/components/chip/GreyChip";
import type { BetEvent } from "~/models/event";
import { PublicLeagueBettingPoolWithBetCount} from "~/services/league/leagueTypes";

export function getPoolActiveStatusChip(
  league: PublicLeagueBettingPoolWithBetCount
): React.ReactNode {
  const now = new Date();
  
  if (!league.closing_date_time) {
    return <GreenChip label={"Pool active"} />;
  }
  
  const leagueEndDate = new Date(league.closing_date_time);

  if (now < leagueEndDate) {
    return <GreenChip label={"Pool active"} />;
  }

  if (now > leagueEndDate) {
    return <GreyChip label={"Pool ended"} />;
  }
}

export function getEventActiveStatusChip(event: BetEvent): React.ReactNode {
  // Since BetEvent doesn't have start/end dates in the current schema,
  // we'll return a default active status
  return <GreenChip label={"Event active"} />;
}

export function getCreatedByText(league: BettingPoolWithCreator) {
  return `Created by 7Qz`;
}

// export function getCreatedByText(league: BettingPoolWithCreator) {
//     if (league.parentPoolId === null) {
//         return `Created by 7Qz`
//     }
//
//     return `Created by ${league.createdBy.username}`
// }
